import { Module } from "vuex";
import { IDashboardState } from "@/core/interfaces/dashboard.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const dashboardModule: Module<IDashboardState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default dashboardModule;
